import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { formatRating } from '../../../../../_shared/helpers/tsHelpers';
import BadgeWithTooltip from '../../../../../_shared/components/BadgeWithTooltip';
import NetworkInfo from '../NetworkInfo';
import Icon from '../../../../../_shared/components/Icon';
import {
  DealerBadges,
  DealerName,
  DealerRatingCount,
  Dealership,
  Divider,
  IconContainer,
  StyledDealerInfo,
  StyledDealerRating,
  StyledStar
} from './Styles';
import { NetworkVariant } from '../../../../../_shared/types/trade';

const propTypes = {
  showIconOnly: PropTypes.bool,
  showBadge: PropTypes.bool
};

const defaultProps = {
  showIconOnly: false,
  showBadge: true
};

const DealerInfo = ({ network, dealer, variant, showIconOnly, showBadge }) => {
  const dealerName = dealer?.displayName || dealer?.name;
  const showFullNetworkInfo = !showIconOnly && network?.isDealerGroupNetwork;
  const showNetworkIconOnly = showIconOnly && network?.isDealerGroupNetwork;
  const showDealerBadge = showBadge && dealer?.dealerBadges?.length > 0;

  return (
    <StyledDealerInfo>
      <Dealership variant={variant}>
        {showFullNetworkInfo && (
          <>
            <NetworkInfo
              displayName={network?.displayName}
              variant={NetworkVariant.ACTIVE}
            />
            <Divider>|</Divider>
          </>
        )}
        {showNetworkIconOnly && (
          <IconContainer>
            <Icon icon="TR5-GroupNetwork" />
          </IconContainer>
        )}
        {showDealerBadge && (
          <DealerBadges>
            <BadgeWithTooltip badges={dealer?.dealerBadges} />
          </DealerBadges>
        )}
        {dealerName && (
          <DealerName shouldCondense={network?.isDealerGroupNetwork}>
            {dealerName}
          </DealerName>
        )}
        {dealer?.rating > 0 && (
          <StyledDealerRating>
            {formatRating(dealer.rating)} <StyledStar />
          </StyledDealerRating>
        )}
        {dealer?.ratingCount > 0 && (
          <DealerRatingCount>
            <FormattedMessage
              id="vdp.seller.ratings"
              values={{ ratingsCount: dealer?.ratingCount }}
            />
          </DealerRatingCount>
        )}
      </Dealership>
    </StyledDealerInfo>
  );
};

DealerInfo.propTypes = propTypes;
DealerInfo.defaultProps = defaultProps;

export default DealerInfo;
